import { render, staticRenderFns } from "./upload-slide.vue?vue&type=template&id=3676a37e&scoped=true&"
import script from "./upload-slide.vue?vue&type=script&lang=js&"
export * from "./upload-slide.vue?vue&type=script&lang=js&"
import style0 from "./upload-slide.vue?vue&type=style&index=0&id=3676a37e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676a37e",
  null
  
)

export default component.exports